const switchToFallback = (image, fallbackSrc) => {
  if (image.getAttribute('src') === fallbackSrc) return
  image.setAttribute('src', fallbackSrc)
}

const applyFaqImageFallback = (image) => {
  const fallbackSrc = image.dataset.fallbackSrc
  if (!fallbackSrc) return

  image.addEventListener(
    'error',
    () => {
      switchToFallback(image, fallbackSrc)
    },
    { once: true }
  )

  // 監視開始前に読み込み失敗していた画像も差し戻す
  if (image.complete && image.naturalWidth === 0) {
    switchToFallback(image, fallbackSrc)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.faqs-show__answer-detail img[data-fallback-src], .backyard-faq-answer-detail img[data-fallback-src]')
    .forEach(applyFaqImageFallback)
})
